module.exports = __webpack_public_path__ + "static/write-4e37f600d6773aea12bcb9808b2761b3.png";